import React from 'react'
import { Founder } from '../../cards/Founder';
import foundersData from '../../../data/FoundersData';

export const Founders = () => {
    return (
        // This is the supporters section
        <div className='px-[5vw] py-20 w-full bg-blue-500 text-white'>
            {/* // This is the title */}
            <h2 className='text-3xl text-white font-semibold'>Founders</h2>

            {/* // This is the view for Large Devices.*/}
            <div className='mt-20 w-full flex flex-wrap gap-3 justify-between items-center'>
                {foundersData.map((item) => (
                    <Founder name={item.name} por={item.por} src={item.src} des={item.description} data={item} />
                ))}
            </div>

        </div>
    )
}
